import { startOfDay, sub } from "date-fns";
import { convertToISO8601 } from "@/lib/utils";

export const siteConfig = {
  title: "Fastboy Payments",
  description: "Fastboy Payments",
  dateFormat: "MM/dd/yyyy",
  dateTimeFormat: "LLL d, yyyy h:mm a",
  last30day: convertToISO8601(sub(startOfDay(new Date()), { days: 30 })),
  table: {
    limit: 10,
    sort: "datetimeStamp.desc",
    defaultPage: 1,
    defaultItemsPerPage: 10,
  },
} as const;
